import {
  FavApp,
  Product as UsageProduct,
} from '@proximus/usage-business-logic';
import {
  isEpicPricingPlan,
  PlcCodes,
  Product,
} from '@dch/products-business-logic';

export function getUsageProductFrom(productOverviewProduct: Product) {
  const product: UsageProduct = new UsageProduct();
  const isEpicPlan = isEpicPricingPlan(productOverviewProduct);
  const favApps: FavApp[] = [];
  if (isEpicPricingPlan(productOverviewProduct)) {
    favApps.push(
      {
        url: productOverviewProduct.activeSubscription.firstFavAppIconPath,
        alt: '',
      },
      {
        url: productOverviewProduct.activeSubscription.secondFavAppIconPath,
        alt: '',
      },
    );
  } else if (productOverviewProduct.favApp) {
    favApps.push({
      url: productOverviewProduct.favApp.iconLocation,
      alt: productOverviewProduct.favApp.name,
    });
  }

  if (productOverviewProduct) {
    product.productId = productOverviewProduct.productId;
    product.plc = PlcCodes[productOverviewProduct.plc];
    product.accessNumber = productOverviewProduct.accessNumber;
    product.contractId = productOverviewProduct.soccabisId;
    product.fonOption = productOverviewProduct.fonOption
      ? productOverviewProduct.fonOption
      : 'none';
    product.brand = productOverviewProduct.brand;
    product.isEpicPlan = isEpicPlan;
    product.favApps = favApps;
    product.productDescription =
      productOverviewProduct.packDescription ||
      productOverviewProduct.productDescription;
  }
  return product;
}

export function overrideSessionStorageOnEmptyHistory(entryPageUrl: string) {
  if (window.history.length <= 1) {
    // Reset the back button history entry page on direct navigation
    sessionStorage.setItem('firstLocationWithBackButton', entryPageUrl);
  }
}
